import configs from 'config/environment'
// const { refreshSession } = require('@utils/authAPI')
import { errorsApi } from './errors.js'

const parseResponse = async (response, contentType) => {
  switch (contentType) {
    case 'text/csv':
    case 'text/plain':
    case 'text/html':
    case 'text/xml':
      return response.text()
    case 'application/pdf':
      return response.blob()
    case 'text/event-stream':
      return response.body
    default:
      return response.json()
  }
}

const handleErrorResponse = (status, parsed) => {
  switch (status) {
    case 405:
      return errorsApi.methodNotAllowed
    case 500:
      return errorsApi.internalServerError
    case 501:
      return errorsApi.notImplemented
    case 502:
      return errorsApi.badGateway
    case 503:
      return errorsApi.tempUnavailable
    case 504:
      return errorsApi.gatewayTimeout
    default:
      return parsed
  }
}

class AdminAPI {
  constructor(config) {
    this.apiUrl = configs.apiUrl
    this.token = config.token
    this.dispatch = config.dispatch
  }

  request(
    endpoint,
    method = 'GET',
    data = null,
    contentType = 'application/json'
  ) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `${this.apiUrl}${endpoint}`
        const res = await fetch(url, {
          method,
          headers: {
            Authorization: `Bearer ${this.token}`,
            'Content-Type': contentType
          },
          body: data ? JSON.stringify(data) : null
        })

        // user token has expired
        // if (res.status === 401 && this.dispatch) {
        //   this.dispatch(refreshSession())
        // }

        if (res.status === 204) {
          return resolve(null)
        }

        const resContentType = res.headers.get('Content-Type')?.split(';')[0]
        if (!resContentType) {
          return reject(errorsApi.internalServerError)
        }

        const parsed = await parseResponse(res, resContentType)
        if (!res.ok) {
          const error = handleErrorResponse(res.status, parsed)
          return reject(error)
        }
        return resolve(parsed)
      } catch (err) {
        return reject(errorsApi.internalServerError)
      }
    })
  }
}

export default AdminAPI
